import { http } from '@shared/libs/http'

export type LoginRequest = {
  email: string
  password: string
  code_challenge: string
}

export type LoginResponse = {
  mfa_required: boolean
  pending_mfa_token: string | null
  needs_email_verify: boolean
}

export async function login(body: LoginRequest) {
  const { data } = await http.post<LoginResponse>('/auth/login', body)
  return data
}

export type MfaVerifyRequest = {
  pending_mfa_token: string
  code: string
  remember_device?: boolean
  device_fingerprint?: string
}

export async function verifyMfa(body: MfaVerifyRequest) {
  await http.post('/auth/mfa/verify', body)
}

export async function sendMfaCode(pending_mfa_token?: string) {
  const body = pending_mfa_token ? { pending_mfa_token } : undefined
  await http.post('/auth/mfa/send', body)
}

export async function logout() {
  await http.post('/auth/logout')
}

export type ForgotPasswordRequest = { email: string }
export async function forgotPassword(body: ForgotPasswordRequest) {
  await http.post('/auth/forgot-password', body)
}

export type ResetPasswordRequest = { email: string; code: string; new_password: string }
export async function resetPassword(body: ResetPasswordRequest) {
  await http.post('/auth/reset-password', body)
}

export type VerifyEmailRequest = { email: string; code: string }
export async function verifyEmail(body: VerifyEmailRequest) {
  await http.post('/auth/verify-email', body)
}

export type ResendCodeRequest = { purpose: 'verify_email' | 'reset_password' | 'mfa'; email: string }
export async function resendCode(body: ResendCodeRequest) {
  await http.post('/auth/resend-code', body)
}
